// Rotating "thinking" messages shown while the agent works (generic, no implied sequence)
export const THINKING_MESSAGES = [
  'Even nadenken…',
  'Cijfers aan het verwerken…',
  'Bezig met je vraag…',
  'SQL aan het opstellen…',
  'BigQuery vriendelijk aan het vragen…',
  'Tabellen aan het koppelen…',
  'Woorden zorgvuldig aan het SELECT-en…',
  'WHERE had ik die data ook alweer…',
  'Gedachten aan het GROUP BY-en…',
  'Sorteren op belangrijkheid…',
  'Sneller dan een full table scan…',
  'Queryplan aan het optimaliseren…',
  'Het datawarehouse aan het opwarmen…',
  'Je vraag aan het ontleden…',
  'Dimensies aan het kruisverwijzen…',
  'Onderhandelen met NULL-waarden…',
  'Het sterschema aan het ontwarren…',
  'Rijen tellen, geen schaapjes…',
  'Een paar window functions toepassen…',
  'CTE\'s, verzamelen!…',
  'Het probleem aan het partitioneren…',
  'Gegevens uit de cloud ophalen…',
  'Cartesische producten vermijden…',
  'Relaties tussen tabellen controleren…',
  'Verwachtingen aan het normaliseren…',
  'Perspectieven aan het pivotten…',
  'CASE WHEN slim THEN antwoord…',
  'Datatypen netjes aan het casten…',
  'Afronden naar een oplossing…',
  'Datapunten aan het correleren…',
  'Statistieken analyseren…',
  'De perfecte query aan het bouwen…',
  'Bijna klaar, echt waar…',
];
